// extracted by mini-css-extract-plugin
export var banner = "_iz-0";
export var closeButton = "_iz-2";
export var greenCheckmark = "_iz-3";
export var hereLink = "_iz-4";
export var titleIcon = "_iz-1";